import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Loader2, AlertCircle, Check } from "lucide-react";

export function ClipPickerDialog({
  open, onClose, loading, clips,
  clipPickerTarget, addressOverlayShotId, closingFrameShotId, wowShots,
  onPickClip
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-white" data-testid="clip-picker-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Sora, sans-serif' }} className="text-[#020B23]">
            Select a Clip
          </DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="flex justify-center py-8"><Loader2 size={24} className="animate-spin text-[#4D11F6]" /></div>
        ) : clips.length === 0 ? (
          <div className="text-center py-8">
            <AlertCircle size={24} className="mx-auto text-[#94969C] mb-2" />
            <p className="text-sm text-[#676970]">No clips available. Generate and select clips in Step 1 first.</p>
          </div>
        ) : (
          <div className="flex flex-col gap-1.5 max-h-[65vh] overflow-y-auto py-1 pr-1">
            {clips.map(clip => {
              const isSelected = clipPickerTarget === 'address'
                ? (addressOverlayShotId === clip.shot_id)
                : clipPickerTarget === 'closing'
                ? (closingFrameShotId === clip.shot_id)
                : clipPickerTarget?.startsWith('wow-') && wowShots[parseInt(clipPickerTarget.split('-')[1])]?.shot_id === clip.shot_id;
              const previewUrl = clip.thumbnail_url || clip.video_url || '';
              return (
                <button key={clip.shot_id + clip.candidate_id} onClick={() => onPickClip(clip)}
                  data-testid={`pick-clip-${clip.shot_id}`}
                  className={`flex items-center gap-3 px-3 py-2 rounded-lg border transition-all w-full text-left ${isSelected ? 'border-[#4D11F6] bg-[#4D11F6]/5 ring-1 ring-[#4D11F6]/30' : 'border-[#E2E4E7] hover:border-[#4D11F6]/40 hover:bg-[#F8F8FC]'}`}>
                  <div style={{
                    width: '56px',
                    height: '56px',
                    minWidth: '56px',
                    borderRadius: '8px',
                    backgroundImage: previewUrl ? `url(${previewUrl})` : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundColor: '#e8e8ee',
                  }} />
                  <span className="text-sm font-medium text-[#1A2238] flex-1 truncate">{clip.room_name}</span>
                  {isSelected && (
                    <div className="w-5 h-5 rounded-full bg-[#4D11F6] flex items-center justify-center shrink-0">
                      <Check size={12} color="white" />
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
